import './chp2/style';
import FormStructure from './chp2/form_structure';

export default FormStructure;